<template>
  <v-row>
    <v-col class="mt-2" cols="12" offset-lg="1" lg="10">
      <v-breadcrumbs :items="breadcrumbs" divider=">" class="pl-1 pb-3" />
      <v-card>
        <v-card-title class="theme mb-5">
          <v-icon class="white--text">card_giftcard</v-icon>
          <span class="headline ml-2 white--text">My Benefits</span>
          <v-spacer />
          <v-btn
            to="/benefit/list"
            depressed
            class="action white--text rounded-sm"
            v-if="isHR"
            >Manage benefits
          </v-btn>
        </v-card-title>
        <v-card-text>
          <v-col cols="12" lg="7" md="6" sm="4"> 
          <div>These are the dedicated benefits that {{companyInfo.name}} offers to all employees. (Insurance, pension scheme, special incentives etc.) You can also visit the <router-link
        to="/benefit/marketplace"
      >marketplace</router-link> for more special offers and deals available to all members of LessAdmin.</div>
          </v-col>
        </v-card-text>
        <v-card-text class="pt-6">
          <v-row justify="center">
            <v-expansion-panels accordion flat>
              <v-expansion-panel v-for="(item, i) in myBenefits" :key="i">
                <v-expansion-panel-header class="text-capitalize"
                  >{{ item.name }}
                </v-expansion-panel-header>
                <div class="px-5">
                  <v-divider />
                </div>
                <v-expansion-panel-content>
                  <v-card flat class="my-5 px-0 mx-0">
                    <v-row>
                      <v-col
                        cols="12"
                        md="3"
                        class="hidden-sm-and-down borderRight pr-5"
                      >
                        <v-row
                          class="fill-height pl-3"
                          align="center"
                          justify="center"
                        >
                          <v-img
                            v-if="item.url"
                            :src="item.url"
                            class="elevation-0"
                          />
                          <v-icon v-else x-large color="theme"
                            >supervisor_account</v-icon
                          >
                        </v-row>
                      </v-col>
                      <v-col cols="12" sm="9" md="9">
                        <v-card-text class="py-0" style="min-height: 150px">
                          <div class="headline mt-n3 theme-text">
                            {{ item.name }}
                          </div>
                          <div class="subtitle-1 mt-2">{{ item.title }}</div>
                          <div class="body-2">
                            Provider: {{ item.provider_name }}
                          </div>
                          <div class="body-2 mt-2">
                            Category: {{ item.category }}
                          </div>
                          <div class="body-2">
                            Location: {{ item.location }}
                            {{ item.sub_location ? item.sub_location : "" }}
                          </div>
                          <div class="body-2 mt-2">{{ item.information }}</div>
                          <!-- <div class="body-2 mt-3">
                            Cost: {{ item.cost }} {{ item.currency }} /
                            {{ item.unit }}
                          </div> -->
                        </v-card-text>
                      </v-col>
                    </v-row>
                  </v-card>
                  <v-divider />
                </v-expansion-panel-content>
              </v-expansion-panel>
            </v-expansion-panels>
          </v-row>
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn
            text
            @click="next"
            :disabled="pagination.disableNext"
            class="theme-text text-capitalize py-2"
            >show More
          </v-btn>
          <v-spacer />
        </v-card-actions>
      </v-card>
    </v-col>
  </v-row>
</template>
<script>
import { mapGetters } from "vuex";

import { Actions } from "@/views/actions";
import { Breadcrumbs } from "@/views/breadcrumbs";
import { Component } from "@/views/component";
import { Constants } from "@/views/constants";

export default {
  name: Component.Protected.Employee.MyBenefits,
  data: () => ({
    breadcrumbs: Breadcrumbs.Employee.MyBenefits,
    myBenefits: [],
    pagination: { disableNext: false, page: 0 },
    search: { type: "", limit: 15, offset: 0, status: "Active" },
    currentLength: 0,
    previousLength: 0,
  }),
  computed: {
    ...mapGetters(["userInfo", "countries", "companyInfo"]),
    isHR() {
      return (
        this.userInfo.role === "HR"
      );
    },
  },
  methods: {
    next() {
      if (
        this.previousLength === 0 ||
        this.currentLength >= this.previousLength
      ) {
        this.pagination.disableNext = false;
        this.pagination.page++;
        this.search.offset = this.search.limit * this.pagination.page;
        this.getBenefits();
      } else {
        this.pagination.disableNext = true;
      }
    },
    getBenefits() {
      this.previousLength = this.currentLength;
      this.$store
        .dispatch(Actions.Benefits.Find, this.search)
        .then((r) => {
          if (r.status === 200) {
            if (!r.data) {
              this.pagination.disableNext = true;
              return false;
            }
            this.currentLength = r.data.length;
            r.data.forEach((el) => this.myBenefits.push(el));
          }
        })
        .catch((err) => {
          console.error(Constants.Benefits.Messages.Error.Find, err);
          this.snackbar = true;
          this.snackbarMessage = Constants.Benefits.Messages.Error.Find;
        });
    },
  },
  created() {
    if (this.userInfo && this.userInfo.role) {
      this.getBenefits();
    } else {
      this.$store.dispatch(Actions.Firebase.UserInfo).then(() => this.getBenefits());
    }
  },
};
</script>
<style scoped>
.borderRight {
  border-right: solid lightgray 1px;
}
</style>